export class Franchise {
    idfranchise: number;
    nom: string;

    constructor({idfranchise = null, nom = null} = {}) {
        this.idfranchise = idfranchise;
        this.nom = nom;
    }
}
